import PropTypes from 'prop-types';
import React from 'react';

const AvatarPlaceholder = ({ size }) => {
    const radius = Math.floor(size / 2);
    return (
        <svg viewBox={`0 0 ${size} ${size}`} className="avatar-placeholder">
            <circle
                cx={radius}
                cy={radius}
                r={radius - 1}
                fill="none"
                strokeWidth="2"
                strokeDasharray="5,4"
                vectorEffect="non-scaling-stroke"
            />
            <text x={radius} y={radius} textAnchor="middle" dominantBaseline="middle">
                
            </text>
        </svg>
    );
};

AvatarPlaceholder.propTypes = {
    size: PropTypes.number.isRequired,
};

export default AvatarPlaceholder;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/avatar-placeholder.jsx